import React from 'react';
import {
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import IntlMessages from '../../utils/IntlMessages';
import FormLoader from '../../components/loader/FormLoader';

const ConfirmModal = ({
  modalOpen,
  toggleModal,
  modalData,
  performModalFunction,
}) => {
  const flagName = [
    'simple-icon-close',
    'simple-icon-check',
    'simple-icon-exclamation',
  ];
  return (
    <Modal
      isOpen={modalOpen}
      toggle={toggleModal}
      backdrop="static"
      className="notification-modal modal-dialog-centered"
      onBackdropClick={toggleModal}
    >
      <ModalBody>
        {/* <div className='d-flex float-right mb-4'>  <button type="button" className="close" aria-label="Close" onClick={toggleModal}><span aria-hidden="true">×</span></button></div> */}
        <div className='d-flex mb-4'>
          <h2 className='m-auto  sim-activation-message text-center'>{modalData.header}</h2>
         
        </div>

        {/* <div className="text-center mt-2">
          <i className={flagName[modalData.isSuccess]}></i>
        </div> */}
      </ModalBody>

      <ModalFooter className="border-0 text-center d-block pt-0">
        <Button outline color="primary btn-lg" onClick={toggleModal}>
        {/* <IntlMessages id="notification.cancel" /> */}
        Cancel
        </Button>
        <Button outline color="primary btn-lg" onClick={(e) => {toggleModal(e), performModalFunction(e) }}>
          {modalData.isLoading ? <FormLoader /> : 
          // <IntlMessages id="notification.ok" />
          "Ok"
           }
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
